import { margins } from '@ohgoodlord/design-system'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  max-height: 52px;
  margin: 0 20px;
  padding: 14px;
`
const StyledUploadedFileSummaryCard = styled.div`
  gap: ${margins.m};
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 80%;
`

const StyledFileIconWrapper = styled.div`
  position: relative;
  height: 22px;
`

const StyledTickIcon = styled.div`
  position: absolute;
  bottom: -8px;
  right: -8px;
`

const TextContainer = styled.div`
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

const RemoveIconWrapper = styled.div`
  justify-self: flex-end;
  cursor: pointer;
`

export const FileSummary = ({
  files,
  handleRemoveFile,
}: {
  files: File[]
  handleRemoveFile: (index: number) => void
}) => (
  <>
    {files.map((file: File, index) => (
      <Wrapper key={index}>
        <StyledUploadedFileSummaryCard>
          <StyledFileIconWrapper>
            <FontAwesomeIcon size="1x" color="#2F80ED" icon="file-text" />
            <StyledTickIcon>
              <FontAwesomeIcon size="xs" color="#6ABD40" icon="circle-check" />
            </StyledTickIcon>
          </StyledFileIconWrapper>
          <TextContainer> {file.name}</TextContainer>
        </StyledUploadedFileSummaryCard>
        <RemoveIconWrapper
          data-testid="remove-file-icon"
          onClick={() => handleRemoveFile(index)}
        >
          <FontAwesomeIcon size="1x" color="#E02020" icon="trash" />
        </RemoveIconWrapper>
      </Wrapper>
    ))}
  </>
)
